import React from "react";

export interface WaitingOptions {
  message: string | React.ReactNode;
  showProgress?: boolean;
  progress?: number; // 0-100
}

type WaitingState = {
  visible: boolean;
  options: WaitingOptions | null;
};

type Listener = (state: WaitingState) => void;

class WaitingManagerClass {
  private static instance: WaitingManagerClass;
  private listeners: Listener[] = [];
  private state: WaitingState = {
    visible: false,
    options: null,
  };

  private constructor() {}

  static getInstance(): WaitingManagerClass {
    if (!WaitingManagerClass.instance) {
      WaitingManagerClass.instance = new WaitingManagerClass();
    }
    return WaitingManagerClass.instance;
  }

  addListener(listener: Listener): void {
    this.listeners.push(listener);
  }

  removeListener(listener: Listener): void {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  show(options: WaitingOptions): void {
    this.state = {
      visible: true,
      options,
    };
    this.notifyListeners();
  }

  hide(): void {
    this.state = {
      ...this.state,
      visible: false,
    };
    this.notifyListeners();
  }

  updateMessage(message: string | React.ReactNode): void {
    if (!this.state.options) return;

    this.state = {
      ...this.state,
      options: {
        ...this.state.options,
        message,
      },
    };
    this.notifyListeners();
  }

  updateProgress(progress: number): void {
    if (!this.state.options) return;

    this.state = {
      ...this.state,
      options: {
        ...this.state.options,
        showProgress: true,
        progress,
      },
    };
    this.notifyListeners();
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener(this.state));
  }
}

export const WaitingManager = WaitingManagerClass.getInstance();
